import SecureLS from 'secure-ls'

const ls = new SecureLS()

function add(key: string, value: string) {
  return ls.set(key, value)
}

function setWithExpiry(key: string, value: string, ttl: number) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + ttl
  }
  add(key, JSON.stringify(item))
}

function remove(key: string) {
  return ls.remove(key)
}

function get(key: string) {
  try {
    return ls.get(key)
  } catch (e) {
    remove(key)
    return null
  }
}

function getWithExpiry(key: string) {
  const itemStr = get(key)
  // if the item doesn't exist, return null
  if (!itemStr) return null

  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    remove(key)
    return null
  }
  return item.value
}

const localStorage = {
  add,
  get,
  remove,
  setWithExpiry,
  getWithExpiry
}

export default localStorage
